export default "__VITE_ASSET__BgCaXSAZ__"